import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { ButtonTypeTokens, InputStateToken } from "@voltmoney/schema";
import { addCommasToNumber, allowDynamicLimitFromBE, getMinAllowedAmountBasedOnLender } from "../../../configs/utils";
import { getTotalLimit } from "../portfolio/actions";
import { ConfigValues } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { MIN_LIMIT } from "../../../configs/constants";
let editedAmount = ConfigValues.MinimumAmountAllowed.toString();
const getUpdateAvailableCAS = (amountRequired, availableCAS, isinNavMap, isinLTVMap) => {
    const updateAvailableCAS = [];
    for (let i = 0; i < availableCAS.length; i++) {
        let item = availableCAS[i];
        let individualAmount = getTotalLimit([item], isinNavMap, isinLTVMap);
        if (amountRequired >= individualAmount) {
            updateAvailableCAS.push(item);
            amountRequired = amountRequired - individualAmount;
        }
        else {
            let ratio = amountRequired / individualAmount;
            let newItem = {
                ...item,
                pledgedUnits: Math.ceil(item.totalAvailableUnits * ratio * 1000) / 1000,
            };
            updateAvailableCAS.push(newItem);
            amountRequired = 0;
        }
    }
    if (amountRequired > 0) {
        /// throw error
        return [];
    }
    return updateAvailableCAS;
};
export const updateSliderAmount = async (action, _datastore, { navigate, setDatastore, asyncStorage, goBack, ...props }) => {
    const isFromMFCentral = action?.payload?.isFromMFCentral;
    const stepResponseObject = action.payload.stepResponseObject;
    const updateAvailableCASMap = {};
    if (parseInt(editedAmount) > 0) {
        stepResponseObject.availableCAS.forEach((item, index) => {
            stepResponseObject.availableCAS[index].pledgedUnits =
                item.totalAvailableUnits;
        });
        stepResponseObject.availableCAS = getUpdateAvailableCAS(parseInt(editedAmount), stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        stepResponseObject.availableCAS.map((item, index) => {
            let key = `${item.isinNo}-${item.folioNo}`;
            updateAvailableCASMap[key] = item;
        });
    }
    else {
        stepResponseObject.availableCAS.map((item, index) => {
            let key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
    }
    await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
    // updateAvailableCASMap ends here
    await SharedPropsService.setCreditLimit(parseInt(editedAmount));
    await navigate(ROUTE.SET_CREDIT_LIMIT, {
        maxAmount: action.payload.maxAmount,
        stepResponseObject: stepResponseObject,
        updateAvailableCASMap: updateAvailableCASMap,
        isFromMFCentral: isFromMFCentral
    });
};
export const sliderAmountOnChange = async (action, _datastore, { setDatastore }) => {
    const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
    editedAmount = action.payload.value;
    const user = action.payload.user;
    const lenderAccountId = user?.linkedApplications[0]?.lenderAccountId;
    const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
    const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
    //@ts-ignore
    const minAmount = allowDynamicLimitFromBEFlag ? minimumEligibleLimit?.amount
        : isEnhancedLimit
            ? MIN_LIMIT.ENHANCE_LIMIT
            : getMinAllowedAmountBasedOnLender(lenderAccountId);
    if (parseInt(editedAmount) >= minAmount && parseInt(editedAmount) <= action.payload.maxAmount) {
        //need to update the updateAvailableCASMap here
        await SharedPropsService.setCreditLimit(parseInt(editedAmount));
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.SUCCESS,
            caption: { error: "" },
        });
        await setDatastore(action.routeId, action.payload.targetWidgetId, {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else if (parseInt(editedAmount) > minAmount) {
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
            caption: { error: `Maximum credit limit allowed is ₹${addCommasToNumber(action?.payload?.maxAmount)}` },
        });
        await setDatastore(action.routeId, action.payload.targetWidgetId, {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
    else {
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
            caption: {
                error: allowDynamicLimitFromBEFlag
                    ? `Minimum credit limit allowed is ₹${addCommasToNumber(minAmount)}`
                    : isEnhancedLimit
                        ? `Minimum credit limit allowed is ₹${addCommasToNumber(MIN_LIMIT.ENHANCE_LIMIT)}`
                        : "Minimum credit limit allowed is ₹25,000"
            },
        });
        await setDatastore(action.routeId, action.payload.targetWidgetId, {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
/*
export const toggleCTA: ActionFunction<any> = async (
  action,
  _datastore,
  { setDatastore }
): Promise<any> => {
  console.log("was toggle cta called?", editedAmount);
  await setDatastore(
    action.routeId,
    action.payload.targetWidgetId,
    <ButtonProps>{
      type:
      editedAmount >= action.payload.minAmount
        ? ButtonTypeTokens.LargeFilled
        : ButtonTypeTokens.LargeOutline,
    }
  );
};
*/
export const getEditAmountOnLoad = async (action, _datastore, { setDatastore }) => {
    const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const minimumAmount = minimumEligibleLimit?.amount;
    const editAmount = await SharedPropsService.getCreditLimit();
    if (editAmount < minimumAmount) {
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
            caption: { error: `Maximum credit limit allowed is ₹${addCommasToNumber(action?.payload?.maxAmount)}` },
            value: `${editAmount}`
        });
    }
    else {
        await setDatastore(ROUTE.UPDATE_SLIDER_AMOUNT, "input", {
            value: `${editAmount}`,
            state: InputStateToken.DEFAULT,
            caption: { error: `` },
        });
    }
};
export const goBack = async (action, _datastore, { navigate, goBack }) => {
    const isFromMFCentral = action?.payload?.isFromMFCentral;
    await navigate(ROUTE.SET_CREDIT_LIMIT, {
        isFromMFCentral: isFromMFCentral
    });
};
